<script lang="ts">
    import { MenuContextCustomActions } from '../MenuDropdown/MenuContextCustomActions';
    import IconCheck from '../../shared/Icons/IconCheck.svelte';
    import IconSettings from '../../shared/Icons/IconSettings.svelte';
    import MenuContextIcon from '../MenuDropdown/MenuContext/MenuContextIcon.svelte';
    import { clientSettings } from '../../../stores/api';
    import { SettingsManager } from '../Settings/SettingsManager';
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    let menu = new MenuContextCustomActions();

    function updateMenu(menu: MenuContextCustomActions) {
        menu.reset();
        menu.addAction({
            id: 'target_date',
            label: get(_)('koloruj piny wg daty'),
            disabled: false,
            visible: true,
            icon: $clientSettings.display.selected_job_color_method === 'target_date' ? IconCheck : null,
            onClick: () => {
                $clientSettings.display.selected_job_color_method = 'target_date';
                SettingsManager.updateClient();
                updateMenu(menu);
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'assigned_vehicle_id',
            label: get(_)('color_pins_by_vehicle'),
            disabled: false,
            visible: true,
            icon: $clientSettings.display.selected_job_color_method === 'assigned_vehicle_id' ? IconCheck : null,
            onClick: () => {
                $clientSettings.display.selected_job_color_method = 'assigned_vehicle_id';
                SettingsManager.updateClient();
                updateMenu(menu);
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'zoom_map_on_every_change',
            label: get(_)('zoom_map_on_change'),
            disabled: false,
            visible: true,
            icon: $clientSettings.display.zoom_map_on_every_change ? IconCheck : null,
            onClick: () => {
                $clientSettings.display.zoom_map_on_every_change = !$clientSettings.display.zoom_map_on_every_change;
                SettingsManager.updateClient();
                updateMenu(menu);
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        })
        menu = menu;
    }

    updateMenu(menu);

</script>

<MenuContextIcon {menu} iconSymbol={IconSettings} />